
(function () {
  const GQL_ENDPOINT = ((window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/') + 'api/2024-07/graphql.json';

  const query = `
    query BundleChildrenImages($productId: ID!) {
      product(id: $productId) {
        id
        metafield(namespace:"custom", key:"bundle_children") {
          type
          references(first: 50) {
            nodes {
              ... on Product {
                id
                title
                featuredImage { url altText width height }
              }
            }
          }
        }
      }
    }
  `;

  document.querySelectorAll('.bundle-vp').forEach((root, idx) => {
    const SF_TOKEN   = root.getAttribute('data-sf-token');
    const PRODUCT_GID = root.getAttribute('data-product-gid');

    if (!SF_TOKEN || !PRODUCT_GID) {
      console.warn('[Bundle VP] Missing storefront token or product gid on block', idx, { SF_TOKEN, PRODUCT_GID });
      return;
    }

    async function fetchChildren() {
      const res = await fetch(GQL_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': SF_TOKEN
        },
        body: JSON.stringify({ query, variables: { productId: PRODUCT_GID } })
      });

      if (!res.ok) throw new Error('Storefront API HTTP ' + res.status);
      const json = await res.json();
      console.debug('[Bundle VP] resp block', idx, json);

      const product = json?.data?.product;
      if (!product) {
        console.warn('[Bundle VP] product=null. Causes: bad GID, product not published to Online Store, or token scope. GID:', PRODUCT_GID);
        return [];
      }
      const mf = product.metafield;
      if (!mf) {
        console.warn('[Bundle VP] metafield=null. Check custom.bundle_children value & exposure.');
        return [];
      }
      if (!/list\.product_reference/i.test(mf.type || '')) {
        console.warn('[Bundle VP] Unexpected metafield type:', mf.type);
      }
      return mf.references?.nodes || [];
    }

    function applyImages(children) {
      const imgs = root.querySelectorAll('[data-bundle-img]');
      imgs.forEach((img) => {
        const idx = Number(img.getAttribute('data-bundle-img'));
        const node = children[idx];
        const ph = img.closest('.evocard__imagewrap')?.querySelector('.evocard__image--placeholder');

        if (node?.featuredImage?.url) {
          const fi = node.featuredImage;
          img.src = fi.url;
          img.alt = fi.altText || node.title || '';
          img.width  = Number(img.getAttribute('width'))  || fi.width  || 110;
          img.height = Number(img.getAttribute('height')) || fi.height || 110;
          img.setAttribute('data-loaded', '1');
          img.removeAttribute('aria-hidden');
          img.classList.remove('evocard__image--placeholder');
          if (ph) ph.classList.remove('is-active');
        } else {
          img.removeAttribute('src');
          img.removeAttribute('data-loaded');
          img.setAttribute('aria-hidden', 'true');
          if (ph) ph.classList.add('is-active');
        }
      });
    }

    fetchChildren()
      .then(applyImages)
      .catch(err => console.error('[Bundle VP] Fetch error block ' + idx + ':', err));
  });
})();